import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';

import ContentLoader from '@components/ContentLoader';

import { FontWeight } from '../../../theme/typography';

/**
 * Right side of common assessment card
 * * contains list of ranges for a metric and where the patient's
 * * measurement falls in
 */

interface RangeSectionProps {
  loading: boolean;
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export default function RangeSection({
  children,
  loading,
  subtitle,
  title,
}: RangeSectionProps) {
  return (
    <Paper
      elevation={0}
      sx={({ palette }) => ({
        p: 2,
        border: `1px solid ${palette.divider}`,
      })}
    >
      <ContentLoader loading={loading}>
        {title || subtitle ? (
          <Stack
            direction="row"
            justifyContent={
              !title ? 'flex-end' : !subtitle ? 'flex-start' : 'space-between'
            }
          >
            {title && (
              <Typography fontWeight={FontWeight.Bold} variant="body2">
                {title}
              </Typography>
            )}
            {subtitle && <Typography variant="body2">{subtitle}</Typography>}
          </Stack>
        ) : null}

        {children}
      </ContentLoader>
    </Paper>
  );
}
